<div class="tw-flex tw-flex-col tw-gap-[40px] tw-pt-[10%] md:tw-pt-[3%]">
    <div
        class="lg:tw-flex tw-hidden tw-items-center tw-justify-between tw-w-4/5 md:tw-w-[90%] lg:tw-w-4/5 tw-mx-auto tw-mt-10 tw-relative"
    >
        <ng-container *ngFor="let step of steps; let i = index">
            <div
                class="tw-relative tw-flex tw-flex-col tw-items-center tw-text-center tw-flex-1"
            >
                <div
                    [ngClass]="
                        val >= step.threshold
                            ? 'tw-text-[#393939]'
                            : 'tw-text-[#a4a4a4]'
                    "
                    class="tw-mb-2 tw-text-sm tw-font-semibold"
                >
                    {{ step.label | translate }}
                </div>
                <div class="tw-relative">
                    <div
                        [ngClass]="
                            val >= step.threshold
                                ? 'tw-bg-blue-500'
                                : 'tw-border tw-border-gray-500'
                        "
                        class="tw-w-4 tw-h-4 tw-rounded-full"
                    ></div>
                </div>
                <div
                    [ngClass]="
                        val >= step.threshold
                            ? 'tw-text-[#000000]'
                            : 'tw-text-[#a4a4a4]'
                    "
                    class="tw-text-sm tw-font-normal !tw-mt-2 !tw-mb-1"
                >
                    {{ step.title | translate }}
                </div>
                <div
                    [ngClass]="{
                        'tw-text-[#393939]': val >= step.threshold,
                        'tw-text-[#a4a4a4]': val < step.threshold,
                        'lg:tw-px-6 xl:tw-px-12': selectedLanguage === 'bm',
                        'tw-px-3': selectedLanguage !== 'bm'
                    }"
                    class="tw-text-sm tw-font-normal md:tw-min-h-[40px]"
                >
                    {{ step.description | translate }}
                </div>
            </div>

            <!-- Connecting line between steps -->
            <div
                *ngIf="i < steps.length - 1"
                [style.left]="step.linePosition"
                [ngClass]="
                    val >= steps[i + 1].threshold
                        ? 'tw-bg-blue-500'
                        : 'tw-bg-gray-300'
                "
                class="tw-absolute md:tw-top-[30%] tw-w-[23.5%] tw-h-0.5 -tw-translate-y-1/2"
            ></div>
        </ng-container>
    </div>

    <div class="lg:tw-hidden md:tw-py-4">
        <div *ngFor="let step of steps; let i = index">
            <div *ngIf="val === step.threshold">
                <div
                    *ngIf="!productName && !financialProductsTitle"
                    class="tw-text-[18px] tw-font-semibold tw-text-[#000000] md:tw-mx-[80px]"
                >
                    {{ "NEW_APPLICATION.FINANCIAL_PRODUCTS" | translate }}
                </div>
                <div
                    class="tw-flex tw-justify-center tw-items-center tw-gap-4 tw-mt-6 md:tw-ml-16"
                >
                    <div
                        class="tw-flex tw-items-center tw-justify-center tw-w-12 tw-h-12 tw-rounded-full tw-bg-[#4B6EEC] tw-text-white tw-font-bold tw-text-[30px] tw-flex-shrink-0"
                    >
                        {{ i + 1 }}
                    </div>
                    <div class="tw-text-left">
                        <div class="!tw-text-[14px] !tw-font-semibold !tw-mb-1">
                            <span class="tw-text-[#000]"
                                >{{ step.label | translate }}:</span
                            >
                            <span class="tw-text-[#393939] tw-pl-1">{{
                                step.title | translate
                            }}</span>
                        </div>
                        <div
                            class="tw-text-[#393939] !tw-text-[14px] !tw-font-normal"
                        >
                            {{ step.description | translate }}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
